/**
 * Check if an offer is a gacha prize
 * Gacha offers are identified by their ref starting with "GACHA-"
 */
export default function isGachaOffer(offer: { ref?: string }): boolean {
  return offer.ref?.startsWith("GACHA-") ?? false;
}
